/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Lp_Login_Headertitle2Inputs */

const en_coinvestments_lp_login_headertitle2 = /** @type {(inputs: Coinvestments_Lp_Login_Headertitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Co-Investments Portal`)
};

/**
* | output |
* | --- |
* | "Co-Investments Portal" |
*
* @param {Coinvestments_Lp_Login_Headertitle2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lp_login_headertitle2 = /** @type {((inputs?: Coinvestments_Lp_Login_Headertitle2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lp_Login_Headertitle2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lp_login_headertitle2(inputs)
});
export { coinvestments_lp_login_headertitle2 as "coInvestments_lp_login_headerTitle" }